export default class FormRules {
  constructor() {
    this.FormRules = document.querySelectorAll('.form-rules');
  }

  init() {
    if (this.FormRules.length > 0) {
      this.showElement();
    }
  }

  showElement() {
    this.FormRules.forEach((formRule) => {
      const showElement = formRule.querySelector('.show-element');
      const showButton = formRule.querySelector('.show-button');
      if (showButton) {
        showButton.addEventListener('click', () => {
          if (showElement.classList.contains('hidden')) {
            showElement.classList.remove('hidden');
            showElement.classList.add('inline');

            const dataHide = showButton.getAttribute('data-hide');

            showButton.innerText = dataHide;
          } else {
            showElement.classList.add('hidden');
            showElement.classList.remove('inline');

            const dataShow = showButton.getAttribute('data-show');

            showButton.innerText = dataShow;
          }
        });
      }
    });
  }
}
